import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AporeportComponent } from '../aporeport/aporeport.component';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuardGuard implements CanDeactivate<AporeportComponent> {
  canDeactivate(component: AporeportComponent): boolean {
    if (component.hasUnsavedChanges()) {
      return window.confirm('You have unsaved changes. Are you sure you want to leave?');
    }
    return true;
  }
}